<template>
	<div class="home">
		<im-nav ref='nav'></im-nav>
		<banner @click="next"></banner>
		<div class="center">
			<div id='item1' class="center-top">
				IM场景解决方案
			</div>
			<div class="center-center">
				<el-tabs :stretch='true' v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="单聊" width='300' name="first">
						<card title="单聊">
							<img class="phone" src="../../public/img/phoneimg/p2.jpg" />
							<img class="phone" src="../../public/img/phoneimg/p3.jpg" />
						</card>
					</el-tab-pane>
					<el-tab-pane label="群聊" name="second">
						<card title="群聊">
							<img class="phone" src="../../public/img/phoneimg/p4.jpg" />
							<img class="phone" src="../../public/img/phoneimg/p5.jpg" />
						</card>
					</el-tab-pane>
					<el-tab-pane label="消息推送" name="third">
						<card title="消息推送">
							<img class="phone" src="../../public/img/phoneimg/p7.jpg" />
							<img class="phone" src="../../public/img/phoneimg/p8.jpg" />
						</card>
					</el-tab-pane>
					
					<el-tab-pane label="私密社交" name="five">
						<card title="私密社交">
							<img class="phone" src="../../public/img/phoneimg/p10.jpg" />
							<img class="phone" src="../../public/img/phoneimg/p9.jpg" />
						</card>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="reg" @click="login()">立即注册，免费试用 -></div>
		</div>
		<div class="center">
			<div id='item2' class="center-top">
				IM核心服务功能
			</div>
			<div class="center-center">
				<mainfun></mainfun>
			</div>
			<div class="reg" @click="login()">立即注册，免费试用 -></div>
		</div>
		<div class="center">
			<div class="center-top">
				IM增值功能
			</div>
			<div class="center-center">
				<morefun></morefun>
			</div>
			<div class="reg" @click="login()">立即注册，免费试用 -></div>
		</div>
		<div class="center">
			<div id='item3' class="center-top">
				IM行业解决方案
			</div>
			<div class="center-center">
				<img src="../../public/img/map.png" class="map" />
			</div>
		</div>
		<div class="last">
			<div id='item4' class="sign">稳定健壮，消息必达，亿级并发的即使通讯云</div>
			<div style="display: flex;flex-direction: row;width: 220px;justify-content: space-between;">
				<div class="btn1" @click="login()">免费试用</div>
				<div class="btn2" @click="login()">立即登陆</div>
			</div>
		</div>
		<footer class="footer">
			<div class="footer-top">
				<div>
					<p>关于我们</p>
					<p><a href="http://lagenai.com">公司简介</a></p>
					<p><a href="https://yofea.com/">关于游帆</a></p>
					<p><a href="https://yofea.com/culture.html">企业文化</a></p>
					<p><a href="https://yofea.com/join.html">招贤纳士</a></p>
				</div>
				<div>
					<p>管理与支持</p>
					<p><a href="http://lagenai.com/html/userAgreement.html">用户协议</a></p>
					<p><a href="http://lagenai.com/html/privacyPolicy.html">隐私政策</a></p>
				</div>
				
				<div>
					<p>相关资源</p>
					<p><a href="https://hisay.im/document.docx">文档下载</a></p>
					<p><a href="https://hisay.im/public/PHPSDK.zip">SDK下载</a></p>
					<p><a href="https://hisay.im/public/HisayUI.zip">案例下载</a></p>
				</div>
				
				<div>
					<p>联系我们</p>
					<p class="p1">咨询热线</p>
					<p>4006969956</p>
					<p class="p1">商务合作</p>
					<p>admin@yfcat.com</p>
					<p class="p1">公司地址</p>
					<p>成都市武侯区美年广场b座a630</p>
				</div>
				<!-- <div style="display: flex;flex-direction: column;align-items: center;">
					<img src="../../public/img/code.png" style="width: 100px;height: 100px;" />
					<div class="bottom-txt">海讯微信公众号</div>
				</div> -->
			</div>
			<mybottom></mybottom>
		</footer>
		<!-- <div class="flot">
			<div class="flot-item">
				<img src="../../public/img/phoneimg/phone1.png" style="width: 80px;height: 80px;border-radius: 5px;" />
			</div>
			<div class="flot-item">
				<img src="../../public/img/phoneimg/phone2.png" style="width: 80px;height: 80px;border-radius: 5px;" />
			</div>
			<div class="flot-item">
				<img src="../../public/img/phoneimg/phone3.png" style="width: 80px;height: 80px;border-radius: 5px;" />
			</div>
			<div class="flot-item">
				<img src="../../public/img/phoneimg/phone4.png" style="width: 80px;height: 80px;border-radius: 5px;" />
			</div>
		</div> -->

	</div>
</template>

<script>
	// @ is an alias to /src
	import imNav from "../components/nav.vue"
	import banner from "../components/banner.vue"
	import card from "../components/card.vue"
	import mainfun from "../components/mainfun.vue"
	import morefun from "../components/morefun.vue"
	import resovefun from "../components/resovefun.vue"
	import mybottom from "../components/mybottom.vue"
	export default {
		name: 'Home',
		components: {
			imNav,
			banner,
			card,
			morefun,
			mainfun,
			resovefun,
			mybottom
		},
		data() {
			return {
				banner: [
					'../../public/img/banner1.png',
					'../../public/img/banner2.png',
				],
				activeName: 'second',
				name:'',
				pwd:''
			}
		},
		created() {
			this.test()
			localStorage.removeItem('Token')
		},
		methods: {
			next(){
				console.log(123)
				this.$el.querySelector(`#item1`).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			login(){
				this.$refs.nav.textlogin()
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			go() {
				this.$router.push('/message/message')
			},
			test() {
				
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	a{
		text-decoration: none;
		font-size:13px;
		color: white;
	}
	.btn2 {
		width: 150px;
		height: 40px;
		font-size: 15px;
		color: white;
		text-align: center;
		line-height: 40px;
		border-radius: 5px;
		margin-left: 10px;
	}
	.btn1,.btn2,.reg:hover{
		cursor: pointer;
	}
	.btn1 {
		background-color: white;
		color: black;
		margin-right: 20px;
		color: #0f73ee;
	}
	
	.btn2 {
		background-color: #fa9630;
	}
	.txt{
		font-size: 15px;
	}
	.txt1{
		width: 100px;
		height: 100px;
	}
	.item{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin: 20px;
	}
	.item1{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content:flex-end;
	}
	.input-box{
		width: 60%;
		border-bottom: 1px solid #222200;
	}
	.form{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	input{
		border: 0px;
		outline: none;
	}
	
	.form{
		width: 100%;
		height: 40%;
		background-color: white;
		border-radius: 5px;
	}
	.flot {
		position: fixed;
		right: 0px;
		top: 100px;
		width: 100px;
		height: 400px;
		z-index: 99999;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
	}

	.flot-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
	}

	.flot-txt {
		color: white;
		font-size: 12px;
	}

	.reg {
		width: 100vw;
		text-align: center;
		font-size: 20px;
		color: #fa9630;
	}

	.footer-top {
		width: 1100px;
		display: flex;
		justify-content: space-between;
		padding-top: 20px;
	}

	p {
		color: white;
		font-size: 13px;
	}

	.p1 {
		color: rgba(255, 255, 255, 0.5);
	}

	.footer {
		width: 100vw;
		height: 350px;
		background-color: #273140;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.bottom-txt {
		font-size: 8px;
		color: white;
	}

	.bottom {
		position: absolute;
		bottom: 0px;
		width: 100%;
		height: 80px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #212a37;
	}

	.sign {
		color: white;
		font-size: 22px;
		margin-bottom: 15px;
	}

	.btn1,
	.btn2 {
		width: 100px;
		height: 30px;
		font-size: 13px;
		color: white;
		text-align: center;
		line-height: 30px;
		border-radius: 5px;
	}

	.btn1 {
		background-color: white;
		color: black;
	}

	.btn2 {
		background-color: #fa9630;
	}

	.last {
		width: 100vw;
		height: 200px;
		background-color: #0f73ee;
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.map {
		width: 1100px;
		height: 500px;
	}

	.txt {
		font-size: 13px;

	}

	.phone {
		width: 200px;
		height: 380px;
		margin-left: 40px;
		border-radius: 5px;
		box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
	}

	.home {
		width: 100vw;
		background-color: white;
	}

	.center {
		width: 100%;
	}

	.center-top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 50px;
		margin-top: 100px;
	}

	.center-center {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 50px;
		margin-top: 100px;
	}
</style>
